module.exports = __webpack_public_path__ + "img/loading.315fa32e.gif";